import { type TFunction } from 'i18next'
import { Download } from 'lucide-react'

import {
    Button, Card, CardContent, CardDescription, CardHeader, CardTitle, Table, TableHeader, TableRow, TableHead, TableBody, TableCell,
} from '@/components/ui'
import type { QuestionStat } from './manage'

interface StatisticsTabProps {
    questionStats: QuestionStat[]
    t: TFunction
}

export function StatisticsTab({ questionStats, t }: StatisticsTabProps) {
    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium">
                            {t('helpdesk.admin.totalQuestions', 'Totaal aantal vragen')}
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold">1,248</div>
                        <p className="text-xs text-muted-foreground">
                            +12.5% {t('helpdesk.admin.fromLastMonth', 'sinds vorige maand')}
                        </p>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium">
                            {t('helpdesk.admin.averageSatisfaction', 'Gemiddelde tevredenheid')}
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold">4.6/5</div>
                        <p className="text-xs text-muted-foreground">
                            +0.3 {t('helpdesk.admin.fromLastMonth', 'sinds vorige maand')}
                        </p>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium">
                            {t('helpdesk.admin.unansweredQuestions', 'Onbeantwoorde vragen')}
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold">23</div>
                        <p className="text-xs text-muted-foreground">
                            -5 {t('helpdesk.admin.fromLastMonth', 'sinds vorige maand')}
                        </p>
                    </CardContent>
                </Card>
            </div>

            <Card>
                <CardHeader>
                    <div className="flex justify-between items-center">
                        <div>
                            <CardTitle>
                                {t('helpdesk.admin.popularQuestions', 'Populaire vragen')}
                            </CardTitle>
                            <CardDescription>
                                {t('helpdesk.admin.popularQuestionsDescription', 'Meest gestelde vragen en hun beoordelingen')}
                            </CardDescription>
                        </div>
                        <Button variant="outline">
                            <Download className="w-4 h-4 mr-2" strokeWidth={1.5} />
                            {t('helpdesk.admin.exportReport', 'Exporteer rapport')}
                        </Button>
                    </div>
                </CardHeader>
                <CardContent>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>{t('helpdesk.admin.question', 'Vraag')}</TableHead>
                                <TableHead className="text-right">{t('helpdesk.admin.count', 'Aantal')}</TableHead>
                                <TableHead className="text-right">{t('helpdesk.admin.rating', 'Beoordeling')}</TableHead>
                                <TableHead>{t('helpdesk.admin.lastAsked', 'Laatst gesteld')}</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {questionStats.map((stat, index) => (
                                <TableRow key={index}>
                                    <TableCell className="font-medium">{stat.question}</TableCell>
                                    <TableCell className="text-right">{stat.count}</TableCell>
                                    <TableCell className="text-right">{stat.averageRating.toFixed(1)}</TableCell>
                                    <TableCell>{stat.lastAsked.toLocaleDateString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </>
    )
} 